import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Tooltip} from '@material-ui/core';

const ConfirmDialog = (props) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        if(props.open) {
            props.callBackOpen(false)
            return
        }

        setOpen(false);
    };

    const confirmAction = () => {
        if(props.open) {
            props.callBackOpen(false)
            props.yesButtonAction();
            return
        }

        setOpen(false);
        props.yesButtonAction();
    }

    return (
        <div>
            {props.customButton ? props.customButton :
                <Tooltip title={props.tooltip} arrow>
                    <Button
                        fullWidth={props.fullWidth}
                        variant={props.variant}
                        color={props.color}
                        onClick={handleClickOpen}>
                        {props.iconButton}
                    </Button>
                </Tooltip>
            }
            <Dialog
                open={props.open ? props.open : open}
                onClose={handleClose}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{cursor: 'move'}} id="draggable-dialog-title">
                    {props.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {props.description}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary"
                            variant="contained">{props.textBack ? props.textBack : "Não"}</Button>
                    <Button onClick={confirmAction} color="secondary"
                            variant="contained">{props.textConfirm ? props.textConfirm : "Sim"}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default ConfirmDialog;